import AlertManagerSimulatorComponent from './AlertManagerSimulator/AlertManagerSimulator'
import TabAlertsComponent from './TabAlerts/TabAlerts'
import TabAlertsSimulatorComponent from './TabAlertsSimulator/TabAlertsSimulator'
import FiltersComponent from './Filters/Filters'
import TabRulesComponent from './TabRules/TabRules'
import TabSimulatorComponent from './TabSimulator/TabSimulator'
import ModalViewRulesComponent from './ModalViewRules/ModalViewRules'
import ModalRiskPonderatorComponent from "./ModalRiskPonderator/ModalRiskPonderator";
import ModalViewSimulationComponent from './ModalViewSimulation/ModalViewSimulation'

export const AlertManagerSimulator = AlertManagerSimulatorComponent
export const TabAlerts = TabAlertsComponent
export const TabAlertsSimulator = TabAlertsSimulatorComponent
export const Filters = FiltersComponent
export const TabRules = TabRulesComponent
export const TabSimulator = TabSimulatorComponent
export const ModalViewRules = ModalViewRulesComponent
export const ModalRiskPonderator = ModalRiskPonderatorComponent
export const ModalViewSimulation = ModalViewSimulationComponent
